import { GraphQLScalarType } from 'graphql';
import Decimal from '@/utils/decimal';

export default new GraphQLScalarType({
  name: 'Decimal',
  serialize(value: Decimal): string {
    return value.toString();
  },
  parseValue(value: string): Decimal {
    return new Decimal(value);
  },
});
